import type { WarehouseResponse } from '@nebalkon-workspace/storage-api';

/** Whether `value` is a warehouse id segment in URL (UUID v4). */
export function isWarehouseUuid(value: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
    value,
  );
}

export function warehouseRouteSegment(
  warehouse: Pick<WarehouseResponse, 'id' | 'slug'>,
): string {
  const slug = warehouse.slug?.trim();
  return slug || warehouse.id;
}
